var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkoutActionDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M148.09,267.25l30.14,603.23c0,68.23,56.45,123.54,126.09,123.54h416.54c69.63,0,126.09-55.31,126.09-123.54l29-603.23H148.09ZM911.19,224.46c.12-25.44.2-27.13.2-28.84,0-66.34-39.27-102.75-91.97-102.75l-146.67.15c0-34.82-34.01-63.05-68.83-63.05h-182.59c-34.81,0-69.93,28.23-69.93,63.05l-146.83-.15c-58.21,0-91.97,44.37-91.97,102.75,0,1.71.07,3.4.2,28.84h798.4,0ZM638.18,425.77c0-19.23,15.59-34.82,34.81-34.82s34.82,15.59,34.82,34.82v398.87c0,19.23-15.59,34.82-34.82,34.82s-34.81-15.59-34.81-34.82v-398.87h0ZM477.18,425.77c0-19.23,15.59-34.82,34.82-34.82s34.82,15.59,34.82,34.82v398.87c0,19.23-15.59,34.82-34.82,34.82s-34.82-15.59-34.82-34.82v-398.87h0ZM316.29,425.77c0-19.23,15.59-34.82,34.82-34.82s34.82,15.59,34.82,34.82v398.87c0,19.23-15.59,34.82-34.82,34.82s-34.82-15.59-34.82-34.82v-398.87h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkoutActionDelete);
export default __webpack_public_path__ + "static/media/workout-action-delete.81dec57188ae12654ea73696dbddb695.svg";
export { ForwardRef as ReactComponent };